(function () {
  if (window.__gbCompareInit) return;
  window.__gbCompareInit = true;

  const KEY = "gbCompareProducts";
  const MAX = 4;

  // --- storage helpers ---
  const get = () => {
    try { return JSON.parse(localStorage.getItem(KEY)) || []; }
    catch { return []; }
  };
  const set = (arr) => localStorage.setItem(KEY, JSON.stringify(arr));
  const has = (id) => get().some(x => String(x.productId) === String(id));

  function broadcastCompareUpdate() {
    window.dispatchEvent(new CustomEvent("gb:compare:updated"));
  }

  // --- counter badge updater ---
  function updateCompareCount() {
    const count = get().length;

    document.querySelectorAll("[data-gb-compare-count]").forEach(el => {
      el.textContent = String(count);
    });

    document.querySelectorAll("[data-gb-compare-count-full]").forEach(el => {
      el.textContent = `${count}/${MAX}`;
    });
  }

  // --- 5s indicator show/hide ---
  let indicatorTimer = null;
  function showIndicator() {
    const el = document.querySelector(".gb-compare-indicator");
    if (!el) return;
    el.classList.add("is-active");
    clearTimeout(indicatorTimer);
    indicatorTimer = setTimeout(() => {
      el.classList.remove("is-active");
    }, 5000);
  }

  // lightweight toast for 4 products
  function showCompareLimitToast(message = "You can only compare up to 4 products.") {
    let t = document.querySelector(".gb-compare-limit-msg");
    if (!t) {
      t = document.createElement("div");
      t.className = "gb-compare-limit-msg";
      t.setAttribute("role", "status");
      t.setAttribute("aria-live", "polite");
      document.body.appendChild(t);
      Object.assign(t.style, {
        position: "fixed",
        right: "16px",
        bottom: "150px",
        background: "#111",
        color: "#fff",
        padding: "10px 14px",
        borderRadius: "8px",
        fontSize: "14px",
        boxShadow: "0 8px 24px rgba(0,0,0,.25)",
        zIndex: 10000,
        opacity: 0,
        transition: "opacity .25s ease"
      });
    }
    t.textContent = message;
    t.style.opacity = 1;
    clearTimeout(t._hide);
    t._hide = setTimeout(() => { t.style.opacity = 0; }, 1800);
  }

  const add = (id) => {
    const items = get();
    if (!has(id)) {
      if (items.length >= MAX) {
        showCompareLimitToast();  // toast
        showIndicator();          // <--- also show counter
        return false;
      }
      items.push({ productId: String(id) });
      set(items);
      updateCompareCount();
      showIndicator();            // normal add
      broadcastCompareUpdate();
    }
    return true;
  };

  const remove = (id) => {
    const next = get().filter(x => String(x.productId) !== String(id));
    set(next);
    updateCompareCount();
    showIndicator();              // show for 5s on remove
    broadcastCompareUpdate();
  };

  // --- UI binding ---
  function init(container = document) {
    const toggles = container.querySelectorAll('.gb-compare-toggle:not([data-gb-bound])');
    toggles.forEach(t => {
      t.dataset.gbBound = "1";
      const pid = String(t.getAttribute('data-pid'));
      const box = t.querySelector('.gb-compare-checkbox');
      if (!box) return;

      // initial state
      box.checked = !!has(pid);

      // toggle behavior
      box.addEventListener('change', () => {
        if (box.checked) {
          const ok = add(pid);
          if (ok === false) {
            showCompareLimitToast();
            box.checked = false;
          }
        } else {
          remove(pid);
        }
      });
    });

    updateCompareCount();
  }

  // keep checkboxes in sync if compare list changes elsewhere
  function refresh(container = document) {
    const toggles = container.querySelectorAll('.gb-compare-toggle');
    toggles.forEach(t => {
      const pid = String(t.getAttribute('data-pid'));
      const box = t.querySelector('.gb-compare-checkbox');
      if (box) box.checked = !!has(pid);
    });
    updateCompareCount();
  }

  // Run now or on DOM ready
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => {
      init();
      updateCompareCount();
    });
  } else {
    init();
    updateCompareCount();
  }

  // Handle dynamically injected cards (infinite scroll, filters, etc.)
  const obs = new MutationObserver(muts => {
    for (const m of muts) {
      for (const n of m.addedNodes || []) {
        if (n.nodeType === 1) init(n);
      }
    }
  });
  obs.observe(document.body, { childList: true, subtree: true });

  // React to updates from other scripts/tabs
  window.addEventListener('gb:compare:updated', () => refresh());
  window.addEventListener('storage', (e) => {
    if (e.key === KEY) refresh();
  });
})();
